import { ThemeProps } from './theme';

/**
 * Generates a sitemap.xml for a white label site
 * - Only includes the home page to prevent duplicate content issues
 * - Adds appropriate metadata and last modification date
 * - Configures priority and change frequency
 */
const generateSitemap = (theme: ThemeProps) => {
  const today = new Date().toISOString();
  const domain = theme.website?.replace(/\/$/, '') || '';
  
  if (!domain) {
    console.error('Cannot generate sitemap: domain is undefined');
    return '';
  }

  // Only include the home page to avoid duplicate content
  const routes = [
    '',  // Home page
  ];

  // Optional routes that could be included if they have unique content
  // Only uncomment these if the pages truly have unique content per white label
  // const optionalRoutes = theme.uniqueContentPages?.filter(Boolean) || [];
  // routes.push(...optionalRoutes);

  const xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  ${routes.map(route => `
    <url>
      <loc>${domain}${route}</loc>
      <lastmod>${today}</lastmod>
      <changefreq>weekly</changefreq>
      <priority>1.0</priority>
    </url>
  `).join('')}
</urlset>`;

  return xml;
};

/**
 * Updates the sitemap in response to theme changes
 * @param theme The current theme
 */
export const refreshSitemap = (theme: ThemeProps): void => {
  try {
    if (theme?.website) {
      const sitemap = generateSitemap(theme);
      // Store in localStorage for quick access
      localStorage.setItem('sitemap_content', sitemap);
      console.debug('Sitemap refreshed for', theme.website);
    }
  } catch (error) {
    console.error('Failed to refresh sitemap:', error);
  }
};

export default generateSitemap;